import { createContext, useContext } from 'react';

const ManageShipmentItemsContext = createContext(null);

export const useManageShipmentItemsContext = () => useContext(ManageShipmentItemsContext);

export default ManageShipmentItemsContext;
